export const addQuestionAction = function (item) {
    return {
        type: "FB_ADD_QUESTION",
        payload: item
    }
};

export const setQuestionsAction = function (items) {
    return {
        type: "FB_SET_QUESTIONS",
        payload: items
    }
};

export const removeQuestionAction = function (item) {
    return {
        type: "FB_REMOVE_QUESTION",
        payload: item
    }
};

export const clearQuestionsAction = function () {
    return {
        type: "FB_CLEAR_QUESTIONS"
    }
};


export const changeQuestionAction = function (item) {
    return {
        type: "FB_CHANGE_QUESTION",
        payload: item
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/questions.js